import { LayerDefinition } from './types';

export const windchillDefinition: LayerDefinition = {
  id: 'windchill',
  name: 'Wind Chill Index',
  category: 'core_met',
  categoryLabel: 'Core Meteorological',
  icon: '🥶',
  description: 'Apparent temperature / wind chill index.',
  sourceModels: ['hrrr', 'rrfs', 'rdps', 'gfs', 'ecmwf', 'icon13'],
  outputModels: ['Wind chill .pmtiles per model'],
  config: {
    defaultModel: 'hrrr'
  }
};

export default windchillDefinition;
